import {
  boolean,
  index,
  pgEnum,
  pgTable,
  text,
  timestamp,
  unique,
  uuid,
  varchar,
} from "drizzle-orm/pg-core"

export const partnerNameEnum = pgEnum("partner_name_enum", ["INVENT"])

export const partnerEntityTypeEnum = pgEnum("partner_entity_type_enum", [
  "ADVISOR",
  "ESTATE",
  "CONTACT",
  "DOCUMENT",
  "ASSET",
])

export const partnerSyncStatusEnum = pgEnum("partner_sync_status_enum", ["SYNCED", "FAILED"])

// Maps partner-side identifiers to Legacy Keeper entities so sync operations are
// idempotent. internalId is a varchar with no FK: it holds both uuid PKs (estates,
// contacts) and Cognito subs (users), and rows are bookkeeping rather than referential
// data — sync repairs stale mappings when the target row no longer exists.
export const partnerExternalMappings = pgTable(
  "partner_external_mapping",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    partnerName: partnerNameEnum("partner_name").notNull(),
    externalId: varchar("external_id", { length: 255 }).notNull(),
    entityType: partnerEntityTypeEnum("entity_type").notNull(),
    // Null while a sync attempt has failed before a target entity was created
    internalId: varchar("internal_id", { length: 255 }),
    // Partner-side ID of the advisor whose sync manages this entity. Lets the sync
    // reconcile clients removed from an advisor's roster and scope failure counts;
    // null for ADVISOR rows (they are the advisor).
    advisorExternalId: varchar("advisor_external_id", { length: 255 }),
    // True only when the sync itself granted the advisor's estate permission, so
    // roster-removal reconciliation never revokes access that pre-existed the
    // partner link (e.g. a manual share). Meaningful on ESTATE rows.
    advisorAccessGranted: boolean("advisor_access_granted").notNull().default(false),
    syncStatus: partnerSyncStatusEnum("sync_status").notNull().default("SYNCED"),
    syncError: text("sync_error"),
    lastSyncedAt: timestamp("last_synced_at").defaultNow().notNull(),
    createdAt: timestamp("created_at").defaultNow().notNull(),
    updatedAt: timestamp("updated_at").defaultNow().notNull(),
  },
  (table) => [
    unique("partner_external_mapping_unique").on(
      table.partnerName,
      table.externalId,
      table.entityType,
    ),
    index("partner_external_mapping_internal_idx").on(
      table.partnerName,
      table.entityType,
      table.internalId,
    ),
    index("partner_external_mapping_advisor_idx").on(
      table.partnerName,
      table.entityType,
      table.advisorExternalId,
    ),
  ],
)
